var map = {
	"./ASSEMBLY.jpg": "34ae",
	"./COLD_KNIFE.jpg": "9caa",
	"./Edit.png": "f9c5",
	"./FIRE.jpg": "5b65",
	"./FOAMING.jpg": "ad7a",
	"./FOAMING_MACHINE.jpg": "dd78",
	"./HT_INJECTION.png": "346a",
	"./MILLING_CUTTER.jpg": "714b",
	"./POWER_EQU.jpg": "b124",
	"./RAY_WELD.jpg": "f0a2",
	"./WELDING_WELD.jpg": "4e9c",
	"./bg.png": "0eef",
	"./interior_panel.jpg": "f50c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4b63";